import React from "react";
import { twMerge } from "tailwind-merge";
export const ImageIcon = ({ src, className = "" }: { className?: string; src: string }) => {
  return (
    <div
      className={twMerge(
        "bg-current icon-mask w-[calc(var(--size)*0.75)] h-[calc(var(--size)*0.75)]",
        className
      )}
      style={{ "--img-icon-bg": `url('${src}')` } as React.CSSProperties}
    ></div>
  );
};
